module.exports = __webpack_public_path__ + "img/jaime_saba.d78b744d.png";